import * as Material from "@mui/material";
import {
    IconChevronLeft,
    IconChevronRight,
    IconMedal,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

import PodiumCard from "./components/PodiumCard";

import "./styles.scss";

function RankingSkeleton() {
    return (
        <div className="challenge-ranking">
            <div className="challenge-ranking__header">
                <Material.Skeleton width={120} height={24} />
            </div>
            <div className="challenge-podium">
                {[0, 1, 2].map((i) => (
                    <div key={i} className="podium-card">
                        <Material.Skeleton
                            variant="circular"
                            width={64}
                            height={64}
                        />
                        <Material.Skeleton
                            width={60}
                            height={14}
                            style={{ marginTop: 6 }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function RankingView({
    loading,
    data,
    scrollRef,
    canScrollLeft,
    canScrollRight,
    scrollBy,
}) {
    const { t } = useTranslation("community");

    if (loading) return <RankingSkeleton />;
    if (!data?.ranking?.length) return null;

    return (
        <div className="challenge-ranking">
            <div className="challenge-ranking__header">
                <Text.h4 contrast={8} left={<IconMedal size={18} />}>
                    {t("gamification.ranking.title")}
                </Text.h4>
                {data.currentUser && (
                    <div className="challenge-ranking__my-pos">
                        <Text.span contrast={4}>{t("gamification.ranking.myPosition")}</Text.span>
                        <Text.span contrast={7} className="bold">
                            #{data.currentUser.position + 1}
                        </Text.span>
                        <Text.span contrast={4}>{data.currentUser.points} pts</Text.span>
                    </div>
                )}
            </div>

            <div className="challenge-podium-wrap">
                {canScrollLeft && (
                    <button
                        type="button"
                        className="challenge-podium__arrow challenge-podium__arrow--left"
                        onClick={() => scrollBy(-1)}
                        aria-label={t("common:actions.previous")}
                    >
                        <IconChevronLeft size={18} />
                    </button>
                )}

                <div className="challenge-podium" ref={scrollRef}>
                    {data.ranking.map((member, i) => (
                        <PodiumCard
                            key={`${member.user_id}-${i}`}
                            member={member}
                            position={i}
                        />
                    ))}
                </div>

                {canScrollRight && (
                    <button
                        type="button"
                        className="challenge-podium__arrow challenge-podium__arrow--right"
                        onClick={() => scrollBy(1)}
                        aria-label={t("common:actions.next")}
                    >
                        <IconChevronRight size={18} />
                    </button>
                )}
            </div>
        </div>
    );
}
